'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
function $is_Lsamples_Sealed$package$Animal$1(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.by)));
}
export { $is_Lsamples_Sealed$package$Animal$1 as $is_Lsamples_Sealed$package$Animal$1 };
function $isArrayOf_Lsamples_Sealed$package$Animal$1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.by)));
}
export { $isArrayOf_Lsamples_Sealed$package$Animal$1 as $isArrayOf_Lsamples_Sealed$package$Animal$1 };
